<table class="eiq-table-skeleton__table">
  <thead>
    <tr class="eiq-table-skeleton__row">
      <th class="eiq-table-skeleton__header"></th>
      <th class="eiq-table-skeleton__header"></th>
      <th class="eiq-table-skeleton__header"></th>
      <th class="eiq-table-skeleton__header"></th>
      <th class="eiq-table-skeleton__header"></th>
      <th class="eiq-table-skeleton__header"></th>
      <th class="eiq-table-skeleton__header"></th>
    </tr>
  </thead>
  <tbody>
    <tr class="eiq-table-skeleton__row">
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
    </tr>
    <tr class="eiq-table-skeleton__row">
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
    </tr>
    <tr class="eiq-table-skeleton__row">
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
    </tr>
    <tr class="eiq-table-skeleton__row">
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
      <td class="eiq-table-skeleton__cell"></td>
    </tr>
  </tbody>
</table>
